var _path, _path2, _g, _rect, _g2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFaqCanvasDrag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4145_3485)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H44C50.6274 0 56 5.37258 56 12V44C56 50.6274 50.6274 56 44 56H12C5.37258 56 0 50.6274 0 44V12Z",
    fill: "#F0F1F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4145_3485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H44C50.6274 0 56 5.37258 56 12V44C56 50.6274 50.6274 56 44 56H12C5.37258 56 0 50.6274 0 44V12Z",
    fill: "#BB1919"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4145_3485)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5 28.5H-26.5V96.5H41.5V28.5ZM-27.5 27.5V97.5H42.5V27.5H-27.5Z",
    fill: "#DADDDE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.5 28.5H42.5V96.5H110.5V28.5ZM41.5 27.5V97.5H111.5V27.5H41.5Z",
    fill: "#DADDDE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5 -40.5H-26.5V27.5H41.5V-40.5ZM-27.5 -41.5V28.5H42.5V-41.5H-27.5Z",
    fill: "#DADDDE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.5 -40.5H42.5V27.5H110.5V-40.5ZM41.5 -41.5V28.5H111.5V-41.5H41.5Z",
    fill: "#DADDDE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.68164,
    y: 7.5,
    width: 25.2578,
    height: 26.8672,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4145_3485)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C8.68629 6 6 8.68629 6 12V30C6 33.3137 8.68629 36 12 36H30C33.3137 36 36 33.3137 36 30V12C36 8.68629 33.3137 6 30 6H12ZM20.7431 7.629L23.4859 9.68608C24.1716 10.2004 24.1716 11.2289 23.4859 11.7432L20.7431 13.8002C20.3194 14.1181 19.7146 13.8157 19.7146 13.286V12.2146H14.3146C13.6598 12.2146 13.2589 12.2158 12.959 12.2403C12.8192 12.2517 12.7347 12.266 12.6834 12.2781C12.6589 12.2839 12.6439 12.2887 12.6358 12.2916C12.628 12.2944 12.6247 12.296 12.6241 12.2963C12.483 12.3683 12.3683 12.483 12.2964 12.6241C12.296 12.6247 12.2944 12.628 12.2916 12.6358C12.2887 12.6439 12.2839 12.6589 12.2781 12.6834C12.266 12.7347 12.2517 12.8192 12.2403 12.959C12.2158 13.2589 12.2146 13.6598 12.2146 14.3146V14.5716C12.2146 15.4001 11.543 16.0716 10.7146 16.0716C9.88618 16.0716 9.21461 15.4001 9.21461 14.5716L9.2146 14.2605C9.21457 13.6769 9.21454 13.1516 9.25024 12.7147C9.28847 12.2467 9.37501 11.7495 9.62333 11.2621C9.98286 10.5565 10.5565 9.98285 11.2621 9.62333C11.7495 9.37501 12.2467 9.28847 12.7147 9.25024C13.1516 9.21454 13.6768 9.21457 14.2605 9.2146L19.7146 9.2146V8.14327C19.7146 7.61354 20.3194 7.31117 20.7431 7.629ZM21.2574 34.371L18.5146 32.314C17.8289 31.7997 17.8289 30.7712 18.5146 30.2569L21.2574 28.1998C21.6812 27.882 22.286 28.1843 22.286 28.7141V29.7855H27.6855C28.3403 29.7855 28.7412 29.7843 29.0412 29.7598C29.1809 29.7484 29.2655 29.7341 29.3168 29.722C29.3412 29.7162 29.3562 29.7114 29.3644 29.7085C29.3722 29.7057 29.3754 29.7041 29.376 29.7037C29.5172 29.6318 29.6319 29.5171 29.7038 29.376L29.7048 29.3738L29.7064 29.37L29.7085 29.3643C29.7115 29.3562 29.7163 29.3412 29.722 29.3167C29.7341 29.2654 29.7485 29.1809 29.7599 29.0411C29.7844 28.7412 29.7855 28.3403 29.7855 27.6855V27.4285C29.7855 26.6 30.4571 25.9285 31.2855 25.9285C32.114 25.9285 32.7855 26.6 32.7855 27.4285L32.7855 27.7396C32.7856 28.3231 32.7856 28.8485 32.7499 29.2854C32.7117 29.7534 32.6251 30.2506 32.3768 30.738C32.0173 31.4436 31.4436 32.0172 30.738 32.3768C30.2507 32.6251 29.7534 32.7116 29.2855 32.7499C28.8485 32.7856 28.3233 32.7855 27.7397 32.7855L22.286 32.7855V33.8568C22.286 34.3865 21.6812 34.6889 21.2574 34.371ZM32.4104 17.1431C32.4104 16.5217 31.9067 16.0181 31.2854 16.0181C30.6641 16.0181 30.1604 16.5217 30.1604 17.1431V23.5714C30.1604 24.1928 30.6641 24.6964 31.2854 24.6964C31.9067 24.6964 32.4104 24.1928 32.4104 23.5714V17.1431ZM13.5756 18.9051C13.6941 18.5733 14.1634 18.5733 14.2819 18.9051L15.0301 21H12.8274L13.5756 18.9051ZM16.0835 23.9495L15.7188 22.9285H12.1387L11.774 23.9495C11.565 24.5347 10.9213 24.8396 10.3362 24.6306C9.75104 24.4216 9.44611 23.7779 9.65508 23.1928L11.4567 18.1484C12.2862 15.8256 15.5712 15.8255 16.4008 18.1484L18.2024 23.1928C18.4113 23.7779 18.1064 24.4216 17.5213 24.6306C16.9362 24.8396 16.2924 24.5347 16.0835 23.9495ZM22.7677 18.2681V19.8751H24.8569C25.3007 19.8751 25.6604 19.5153 25.6604 19.0716C25.6604 18.6278 25.3007 18.2681 24.8569 18.2681H22.7677ZM22.7677 22.1251H24.8569C26.5433 22.1251 27.9104 20.758 27.9104 19.0716C27.9104 17.3852 26.5433 16.0181 24.8569 16.0181H21.8332C21.1067 16.0181 20.5177 16.607 20.5177 17.3335V23.5714C20.5177 24.1928 21.0214 24.6964 21.6427 24.6964C22.264 24.6964 22.7677 24.1928 22.7677 23.5714V22.1251Z",
    fill: "#8D4DFF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4775 26.862C33.0942 26.8182 32.6964 26.8443 32.3011 26.9502C30.6154 27.4018 29.615 29.1345 30.0667 30.8203L32.4165 39.5899L30.0901 37.637C28.5745 36.3647 26.3203 36.5358 25.0141 38.0223C23.6978 39.5203 23.8314 41.7984 25.3138 43.1322L32.6049 49.6926C35.067 51.9079 38.3462 52.9875 41.6428 52.668L41.9263 52.6405C49.0412 51.9509 53.834 45.0375 51.9839 38.1328L49.8078 30.0115C49.3561 28.3258 47.6234 27.3254 45.9377 27.7771C45.5424 27.883 45.1847 28.0594 44.8747 28.2891L44.5155 26.9487C44.0638 25.263 42.3311 24.2626 40.6454 24.7143C40.2495 24.8204 39.8913 24.9972 39.5809 25.2274C39.1037 23.5795 37.393 22.6094 35.7282 23.0554C34.0637 23.5015 33.0674 25.1965 33.4775 26.862Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8012 37.3774L38.6327 25.5527C38.324 24.4005 37.1396 23.7167 35.9874 24.0254V24.0254C34.8351 24.3342 34.1513 25.5185 34.4601 26.6708L37.6285 38.4955",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3456 37.6452L43.5499 27.2116C43.2412 26.0593 42.0568 25.3755 40.9046 25.6843V25.6843C39.7523 25.993 39.0686 27.1774 39.3773 28.3296L41.8375 37.5112",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.347 37.6527L44.6696 31.3924C44.3608 30.2401 45.0446 29.0557 46.1969 28.747V28.747C47.3491 28.4383 48.5335 29.1221 48.8422 30.2743L51.0183 38.3956C52.7085 44.7034 48.3301 51.0192 41.8302 51.6492L41.5467 51.6767C38.5293 51.9691 35.5277 50.981 33.2741 48.9532L25.983 42.3929C24.9078 41.4254 24.8109 39.773 25.7656 38.6864V38.6864C26.7131 37.6082 28.3482 37.4841 29.4475 38.4069L34.2018 42.398",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6286 38.4899L35.2056 29.4474C34.8969 28.2952 33.7125 27.6114 32.5603 27.9201V27.9201C31.408 28.2289 30.7242 29.4132 31.033 30.5655L34.2014 42.3902",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4145_3485",
    x: -19,
    y: -9,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4145_3485"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.101961 0 0 0 0 0.141176 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4145_3485"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4145_3485",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4145_3485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFaqCanvasDrag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/faq_canvas_drag.d855449b768733d6ffe35e19cee74437.svg";